// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2L1fJ","footer":"ChangeClinic_footer__eE79c"};